<!--  -->
<template>
    <div class="bod">
    <Breadcrumb style="margin-top: 20px;margin-left: 163px;margin-bottom: 20px;color: rgb(110, 114, 117);">
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem to="/message">相关资讯</BreadcrumbItem>
        <BreadcrumbItem>详情</BreadcrumbItem>
    </Breadcrumb>
      <div class="flex">
        <div style="width: 630px;" class="biaoti">
            黄埔区妇女就业创业技能培训顺利开展
        </div>
      </div>
      <div class="flex">
      <div class="xgleft3"></div>
        <div class="xgleft4">就业创业</div>
        <div class="xgleft1">发布时间：&nbsp&nbsp2022.09.06</div>
      </div>
      <div class="flex">
        <div class="wenben1" style="margin-bottom: 0;">
            为了提升黄埔区妇女就业创业能力，推动妇女融入社会，实现灵活就业创业，激发我区广大妇女群众积极投身经济社会高质量发展，9月6日上午，在区妇联主办和支持下黄埔区朝九晚四巾帼创客服务中心在萝岗街党群服务中心开展妇女就业创业技能培训，来自萝岗街、联和街、长岭街、云埔街的40多名妇女参加本次培训班。
        </div>
      </div>
      <div class="flex">
        <div class="page5tu1"></div>
      </div>
      <div class="flex">
        <div style="margin-bottom: 50px;" class="wenben2">        本次培训采取课堂授课与现场实操相结合的方式，邀请具有丰富电商直播经验的专业老师来为大家授课，内容围绕“直播电商基础逻辑”、“短视频拍摄及剪辑”、“文案编辑”、“直播间硬件建设”等进行深入讲解。大家紧跟老师步伐，拍视频、写文案，主动交流，争相参与，收获满满。</div>
      </div>
      <div class="flex">
        <div class="page5tu2"></div>
      </div>
      <div class="flex">
        <div style="margin-left: 200px;margin-bottom: 0;height: 50px;" class="wenben3">                接下来，朝九晚四创客服务中心在妇联的支持下将就业创业培训陆续送进我区各个街镇，为助力妇女创业增收，推进我区妇女创业就业迈出扎扎实实的第一步。</div>
      </div>
      <div class="flex">
        <div class="page5tu3"></div>
      </div>
      <div class="flex">
        <hr class="hr1"/>
      </div>
      <div style="margin-left: 163px;float: left;">
        <div class="next">上一篇</div>
        <div class="nextkuang">
          <div class="xgleft1">2023.02.07</div>
          <router-link to="/page4" class="text1">区妇联王主席视察朝九晚四，推进妇女灵活就业工作</router-link>
          <div class="xgleft3"></div>
          <div class="xgleft4">各界关怀</div>
          <router-link to="/page4" class="text2">2023年2月7日上午，黄埔区妇联主席王晓红带队莅临朝九晚四创客中心，指导朝九晚四妇女灵活就业工作。中心理事长王盛虎先生对朝九晚四2023年宏“兔”计划做了详细介绍。王晓红主席充分肯定朝九晚四在妇女灵活就业方面的成果，希望2023年能大力推进落实工作计划，开发朝九晚四灵活就业岗位......</router-link>
          <router-link to="/page4"><div class="text3">查看详情<img src="../../../assets/images/you.png"></div></router-link>
        </div>
      </div>
      <div style="margin-left: 75px;float: left;">
        <div class="next">下一篇</div>
        <div class="nextkuang">
          <div class="xgleft1">2022.08.23</div>
          <router-link to="/page6" class="text1">【公益创投 暖席广州】朝九晚四“三步学会电商直播”主题培训</router-link>
          <div class="xgleft3"></div>
          <div class="xgleft4">就业创业</div>
          <router-link to="/page6" class="text2">为了充分发挥妇女能顶半边天的作用，结合灵活就业的大趋势，盘活乡村妇女劳动力， 2022年8月23日上午，第九届广州市社会组织公益创投活动“乡村振兴，社企共建——困境妇女直播技能提升帮扶计划......</router-link>
          <router-link to="/page6"><div class="text3">查看详情<img src="../../../assets/images/you.png"></div></router-link>
        </div>
      </div>
      <div class="clean"></div>
    </div>
  
  </template>
  
  <script>
  export default {
    data() {
      return {
  
      }
    },
    methods: {
  
    },
    created() {
  
    }
  }
  </script>
  
  <style lang="less" scoped>
  @import "./page.less";
  </style>
  